import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var TriangleDownIcon = function (_a) {
    var className = _a.className;
    return (jsxs("svg", __assign({ className: className, width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "triangle down" }), jsx("path", { d: "M4.06752 5C3.6436 5 3.41202 5.49443 3.68341 5.82009L7.61589 10.5391C7.81579 10.7789 8.18421 10.7789 8.38411 10.5391L12.3166 5.82009C12.588 5.49443 12.3564 5 11.9325 5H4.06752Z", fill: "currentColor" })] })));
};

export { TriangleDownIcon };
